'use strict';

import * as Props from '../Props';

const angular = require('angular');

const ButtonPropertise = {
    Basic: {
        'ControlType': 'Button',
        'Text': {
            name: 'text',
            selectedValue: 'Button',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Button'),
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },       
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.styleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: {
            selectedValue: 'Events',
            hideSection: false,
            hidden: true
        },
        load: angular.copy(Props.elementEventsObject).load,
        click: {
            name: 'onClick',
            type: 'event',
            selectedValue: '',
            xmlValue: '',
            onClickFunction: 'openCodeEditorDialog'
        },
    },
    Size: {
        'Height': {
            name: 'height',
            selectedValue: 'auto',
            type: 'textbox'
        },
        'Width': {
            name: 'width',
            selectedValue: 'auto',
            type: 'textbox'
        },
        'Name': {
            selectedValue: 'Size',
            hidden: true
        }
    }
};
 
   

export default ButtonPropertise;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Button.ts